import type { FunctionComponent } from 'react';
import { AtlassianNavigation } from '@atlaskit/atlassian-navigation';
import Account from '@atlassian/account';
import NavLogo from './NavLogo';
import TrelloLogoComponent from './TrelloLogo';
import { useSwitchAccountLink, useUser } from '#definitions/user';
import { EnvironmentType } from '@atlassian/account/dist/types/utils';
import { useToken } from '../../Flow/ConsentContextProvider';

const NavContents: FunctionComponent = () => {
  const { serviceType } = useToken();
  return (
    <AtlassianNavigation
      label="site"
      primaryItems={[]}
      renderSignIn={Profile}
      renderProductHome={
        serviceType == 'Trello' ? TrelloLogoComponent : NavLogo
      }
    />
  );
};

const Profile = () => {
  const user = useUser();
  const switchAccountLink = useSwitchAccountLink(false);

  return (
    <Account
      testId="account-menu"
      name={user?.name}
      picture={user?.picture}
      email={user?.email}
      identityEnvironment={determineIdentityEnvironment()}
      application="atlassian-consent-screen"
      continueUrl={switchAccountLink}
      isLoggedOut={!user}
      currentTheme={'auto'}
    />
  );
};

function determineIdentityEnvironment(): EnvironmentType {
  switch (process.env.ENV_TYPE) {
    case 'stg':
      return 'staging';
    case 'prod':
      return 'prod';
    case 'stg-fedm':
      return 'staging-fedramp-moderate';
    case 'prod-fedm':
      return 'prod-fedramp-moderate';
    default:
      return 'dev';
  }
}

export default NavContents;
